
<template>
	<i>
		<svg width='24' height='24' viewBox='0 0 24 24' fill='none'><path d='M12.01 2C6.49002 2 2.02002 6.48 2.02002 12C2.02002 17.52 6.49002 22 12.01 22C17.54 22 22.02 17.52 22.02 12C22.02 6.48 17.54 2 12.01 2ZM12.02 20C7.60002 20 4.02002 16.42 4.02002 12C4.02002 7.58 7.60002 4 12.02 4C16.44 4 20.02 7.58 20.02 12C20.02 16.42 16.44 20 12.02 20ZM15.52 11C16.35 11 17.02 10.33 17.02 9.5C17.02 8.67 16.35 8 15.52 8C14.69 8 14.02 8.67 14.02 9.5C14.02 10.33 14.69 11 15.52 11ZM8.52002 11C9.35002 11 10.02 10.33 10.02 9.5C10.02 8.67 9.35002 8 8.52002 8C7.69002 8 7.02002 8.67 7.02002 9.5C7.02002 10.33 7.69002 11 8.52002 11ZM12.02 17.5C14.05 17.5 15.82 16.39 16.77 14.75C16.96 14.42 16.72 14 16.33 14H7.71002C7.33002 14 7.08002 14.42 7.27002 14.75C8.22002 16.39 9.99002 17.5 12.02 17.5Z' fill='#323232'/></svg>
	</i>
</template>

<script>
export default {
	name: `b-new-b-icon-tag-faces`,
	components: {},
	computed: {},
	props: {
		spin: {
			type: Boolean,
			default: false
		}
	},
	mounted() {
		if(this.spin){
			this.$nextTick(() => this.$el.classList.add('spin'));
		}
	}
};
</script>

<style scoped lang="scss">
i {
	display: inline-block;
	vertical-align: middle;

	svg {
		width: 1em;
		height: auto;
		display: block;
	}

	*:not([fill='none']) {
		fill: currentColor;
	}
}

path.a {
	fill: none;
}

.spin {
	animation: rotation 2s infinite linear;
}

@keyframes rotation {
	from {
		transform: rotate(0deg);
	}
	to {
		transform: rotate(359deg);
	}
}
</style>

<docs>
    IconTagFaces

    ```js
    <b-new-b-icon-tag-faces />
    ```
</docs>


